/**
  不会出现在菜单中的基本路由
  wk 2019-11-29
*/

import Main from "../views/Main";

const otherRouters = {
  path: "/",
  name: "otherRouters",
  component: Main,
  children: [
    // {
    //   path: "/pileStationDetail",
    //   name: "pileStationDetail",
    //   meta: {
    //     parent: ["chargeManage", "pileStationList"],
    //     current: ["pileStationList"],
    //   },
    //   component: () =>
    //     import("../views/charging-manage/pile-station/detail.vue"),
    // },
    // {
    //   path: "/reportDetail",
    //   name: "reportDetail",
    //   meta: {
    //     parent: ["chargeManage", "pileStationList"],
    //     current: ["pileStationList"],
    //   },
    //   component: () =>
    //     import("../views/charging-manage/pile-station/report-detail.vue"),
    // },
    // {
    //   path: "/postageDetail",
    //   name: "postageDetail",
    //   meta: {
    //     parent: ["chargeManage", "pileStationList"],
    //     current: ["pileStationList"],
    //   },
    //   component: () =>
    //     import("../views/charging-manage/pile-station/postage-detail.vue"),
    // },
    // {
    //   path: "/settlementDetail",
    //   name: "settlementDetail",
    //   meta: {
    //     parent: ["chargeManage", "pileStationList"],
    //     current: ["pileStationList"],
    //   },
    //   component: () =>
    //     import("../views/charging-manage/pile-station/settlement-detail.vue"),
    // },

    {
      path: "/pileModelDetail",
      name: "pileModelDetail",
      meta: {
        parent: ["chargeManage", "pileModelList"],
        current: ["pileModelList"],
      },
      component: () => import("../views/charging-manage/pile-model/detail.vue"),
    },

    // {
    // 	path: '/pileDetailTab/:id',
    // 	name: 'pileDetailTab',
    // 	meta:{
    // 		parent: ['chargeManage','pileList'],
    // 		current: ['pileList'],
    // 	},
    // 	component: () => import('../views/charging-manage/pile/detail.vue')
    // },

    // {
    //   path: "/pileDetail",
    //   name: "pileDetail",
    //   meta: {
    //     parent: ["chargeManage", "pileList"],
    //     current: ["pileList"],
    //   },
    //   component: () => import("../views/charging-manage/pile/pile-detail.vue"),
    // },
    {
      path: "/repairDetail/:id",
      name: "repairDetail",
      meta: {
        parent: ["chargeManage", "pileList"],
        current: ["pileList"],
      },
      component: () =>
        import("../views/charging-manage/pile/repair-detail.vue"),
    },
    {
      path: "/relationNum",
      name: "relationNum",
      meta: {
        parent: ["chargeManage", "pileList"],
        current: ["pileList"],
      },
      component: () =>
        import("../views/charging-manage/pile/relation-number.vue"),
    },
    {
      path: "/repairAddDetail",
      name: "repairAddDetail",
      meta: {
        parent: ["chargeManage", "pileList"],
        current: ["pileList"],
      },
      component: () =>
        import("../views/charging-manage/pile/repair-add-detail.vue"),
    },
    {
      path: "/pileReportDetail",
      name: "pileReportDetail",
      meta: {
        parent: ["chargeManage", "pileList"],
        current: ["pileList"],
      },
      component: () =>
        import("../views/charging-manage/pile/report-detail.vue"),
    },
    {
      path: "/pileChargeDetail",
      name: "pileChargeDetail",
      meta: {
        parent: ["chargeManage", "pileList"],
        current: ["pileList"],
      },
      component: () =>
        import("../views/charging-manage/pile/charge-detail.vue"),
    },
    {
      path: "/repairListDetail",
      name: "repairListDetail",
      meta: {
        parent: ["chargeManage", "pileList"],
        current: ["pileList"],
      },
      component: () => import("../views/charging-manage/pile/repair-list.vue"),
    },
    {
      path: "/faultDetail",
      name: "faultDetail",
      meta: {
        parent: ["chargeManage", "pileList"],
        current: ["pileList"],
      },
      component: () => import("../views/charging-manage/pile/fault-detail.vue"),
    },
    {
      path: "/custDetail",
      name: "custDetail",
      meta: {
        parent: ["custManage", "custManageList"],
        current: ["custManageList"],
      },
      component: () => import("../views/cust-manage/cust-detail.vue"),
    },
    {
      path: "/orderDetail",
      name: "orderDetail",
      meta: {
        parent: ["orderManage", "orderManageList"],
        current: ["orderManageList"],
      },
      component: () =>
        import("../views/order-manage/order-pile-manage/detail.vue"),
    },
    {
      path: "/emptySwitchActivityDetail",
      name: "emptySwitchActivityDetail",
      meta: {
        parent: ["marketingActivity", "emptySwitchActivity"],
        current: ["emptySwitchActivityList"],
      },
      component: () =>
        import("../views/marketingActivity/emptySwitchActivity/detail.vue"),
    },
    {
      path: "/pileDonationActivityDetail",
      name: "pileDonationActivityDetail",
      meta: {
        parent: ["marketingActivity", "pileDonationActivity"],
        current: ["pileDonationServiceList"],
      },
      component: () =>
        import("../views/marketingActivity/pileDonationActivity/detail.vue"),
    },
    {
      path: "/pilePayingDetail",
      name: "pilePayingDetail",
      meta: {
        parent: ["orderManage", "payOrderList"],
        current: ["payOrderList"],
      },
      component: () =>
        import("../views/order-manage/order-pile-paying/detail.vue"),
    },

    // {
    //   path: "/dealerDetail",
    //   name: "dealerDetail",
    //   meta: {
    //     parent: ["dealerManage", "dealerManageList"],
    //     current: ["dealerManageList"],
    //   },
    //   component: () => import("../views/dealer-manage/detail.vue"),
    // },
    // {
    //   path: "/dealerReportDetail",
    //   name: "dealerReportDetail",
    //   meta: {
    //     parent: ["dealerManage", "dealerManageList"],
    //     current: ["dealerManageList"],
    //   },
    //   component: () => import("../views/dealer-manage/report-detail.vue"),
    // },
    // {
    //   path: "/accountsReviewDetail",
    //   name: "accountsReviewDetail",
    //   meta: {
    //     parent: ["financeManage", "accountsReviewList"],
    //     current: ["accountsReviewList"],
    //   },
    //   component: () =>
    //     import("../views/finance-manage/accounts-review/detail.vue"),
    // },
    // {
      
    //   path: "/financeReviewDetail",
    //   name: "financeReviewDetail",
    //   meta: {
    //     parent: ["financeManage", "financeReviewList"],
    //     current: ["financeReviewList"],
    //   },
    //   component: () =>
    //     import("../views/finance-manage/finance-review/detail.vue"),
    // },

    {
      path: "/serviceRecordDetail",
      name: "serviceRecordDetail",
      meta: {
        parent: ["serviceRecord", "serviceRecordList"],
        current: ["serviceRecordList"],
      },
      component: () => import("../views/service-record/detail.vue"),
    },
    {
      path: "/userManageDetail",
      name: "userManageDetail",
      meta: {
        parent: ["systemManage", "userManageList"],
        current: ["userManageDetail"],
      },
      component: () =>
        import("../views/basicData-manage/user-manage/detail.vue"),
    },
    {
      path: "/roleManageDetail",
      name: "roleManageDetail",
      meta: {
        parent: ["systemManage", "roleManageList"],
        current: ["roleManageDetail"],
      },
      component: () =>
        import("../views/basicData-manage/role-manage/detail.vue"),
    },
    {
      path: "/noticeDetail",
      name: "noticeDetail",
      meta: {
        parent: ["mobileManage", "noticeList"],
        current: ["noticeDetail"],
      },
      component: () => import("../views/mobile-manage/notice/detail.vue"),
    },
    {
      path: "/openScreenDetail",
      name: "openScreenDetail",
      meta: {
        parent: ["mobileManage", "openScreenList"],
        current: ["openScreenDetail"],
      },
      component: () => import("../views/mobile-manage/open-screen/detail.vue"),
    },
    {
      path: "/bannerDetail",
      name: "bannerDetail",
      meta: {
        parent: ["mobileManage", "bannerList"],
        current: ["bannerDetail"],
      },
      component: () => import("../views/mobile-manage/banner/detail.vue"),
    },
    // 消息设置 - 新增编辑页面
    {
      path: "/messageDetail",
      name: "messageDetail",
      meta: {
        parent: ["mobileManage", "bannerList"],
        current: ["bannerDetail"],
      },
      component: () => import("../views/mobile-manage/message/detail.vue"),
    },
    // 车辆型号管理 - 新增编辑页面
    {
      path: "/carDetail",
      name: "carDetail",
      meta: {
        parent: ["mobileManage", "bannerList"],
        current: ["bannerDetail"],
      },
      component: () => import("../views/mobile-manage/car/detail.vue"),
    },
    {
      path: "/pileDetailTab",
      name: "pileDetailTab",
      meta: {
        parent: ["chargeOrderManage", "privateChargeData"],
        current: ["normalList"],
      },
      component: () =>
        import(
          "../views/charging-manage/pile-charge/private-charge-data/detail.vue"
        ),
    },
    {
      path: "/publiPileDetail",
      name: "publiPileDetail",
      meta: {
        parent: ["chargeOrderManage", "publicChargeData"],
        current: ["publicNormalList"],
      },
      component: () =>
        import(
          "../views/charging-manage/pile-charge/public-charge-data/detail.vue"
        ),
    },
    {
      path: "/sharedChargingDetail",
      name: "sharedChargingDetail",
      meta: {
        parent: ["chargeOrderManage", "personalSattion"],
        current: ["sharedChargingOrders"],
      },
      component: () =>
        import(
          "../views/charging-manage/personal-station/shared-charging-order/detail.vue"
        ),
    },
    {
      path: "/sharedBookingDetail",
      name: "sharedBookingDetail",
      meta: {
        parent: ["chargeOrderManage", "personalSattion"],
        current: ["sharedBookingOrders"],
      },
      component: () =>
        import(
          "../views/charging-manage/personal-station/shared-booking-order/detail.vue"
        ),
    },
    {
      path: "/pileUnusualDetail",
      name: "pileUnusualDetail",
      meta: {
        parent: ["chargeOrderManage", "privateChargeData"],
        current: ["unusualList"],
      },
      component: () =>
        import(
          "../views/charging-manage/pile-charge/private-charge-data/detail.vue"
        ),
    },
    {
      path: "/publipileUnusualDetail",
      name: "publipileUnusualDetail",
      meta: {
        parent: ["chargeOrderManage", "publicChargeData"],
        current: ["publicUnusualList"],
      },
      component: () =>
        import(
          "../views/charging-manage/pile-charge/public-charge-data/detail.vue"
        ),
    },
    {
      path: "/companyDetail",
      name: "companyDetail",
      meta: {
        parent: ["SupertubeDataManage"],
        current: ["company_list"],
      },
      component: () =>
        import("../views/supertube-data/company-manage/detail.vue"),
    },
    {
      path: "/sysAdminDetail",
      name: "sysAdminDetail",
      meta: {
        parent: ["companySysManage"],
        current: ["company_list"],
      },
      component: () =>
        import("../views/supertube-data/com-sys-manage/detail.vue"),
    },
    {
      path: "/serverDetail",
      name: "serverDetail",
      meta: {
        parent: ["serverManage"],
        current: ["company_list"],
      },
      component: () =>
        import("../views/supertube-data/server-manage/detail.vue"),
    },
    {
      path: "/custData",
      name: "custData",
      meta: {
        parent: ["userDataManage"],
        current: ["custList"],
        // title: "客户信息",
      },
      component: () => import("../views/userData-manage/main-tab.vue"),
    },
    {
      path: "/pileDetail",
      name: "pileDetail",
      meta: {
        parent: ["pileManage"],
        current: ["pileList"],
        // title: "客户信息",
      },
      component: () =>
        import("../views/userData-manage/pile-manage/main-pileTab.vue"),
    },
    {
      path: "/shareSwitchDetail",
      name: "shareSwitchDetail",
      meta: {
        parent: ["pileManage"],
        current: ["sharedSwitch"],
        // title: "客户信息",
      },
      component: () =>
        import("../views/userData-manage/share-switch/main-pileTab.vue"),
    },
    {
      path: "/VehicleBrandDetail",
      name: "VehicleBrandDetail",
      meta: {
        parent: ["systemManage", "VehicleManagement"],
        current: ["brandList"],
        // title: "客户信息",
      },
      component: () =>
        import(
          "../views/basicData-manage/VehicleManagement/VehicleBrand/detail.vue"
        ),
    },
    {
      path: "/VehicleModelDetail",
      name: "VehicleModelDetail",
      meta: {
        parent: ["systemManage", "VehicleManagement"],
        current: ["brandList"],
        // title: "客户信息",
      },
      component: () =>
        import(
          "../views/basicData-manage/VehicleManagement/VehicleModel/detail.vue"
        ),
    },
    {
      path: "/ChargingPileDetail",
      name: "ChargingPileDetail",
      meta: {
        parent: ["systemManage"],
        current: ["ChargingPile"],
        // title: "客户信息",
      },
      component: () =>
        import("../views/basicData-manage/ChargingPile/detail.vue"),
    },
    {
      path: "/ChargingPileEmbeddedVersion",
      name: "ChargingPileEmbeddedVersion",
      meta: {
        parent: ["systemManage"],
        current: ["ChargingPile"],
      },
      component: () =>
        import("../views/basicData-manage/ChargingPile/embedded-version-form.vue"),
    },
    {
      path: "/upgradeDetail",
      name: "upgradeDetail",
      meta: {
        parent: ["deviceManage", "UpgradeManagement"],
        current: ["UpgradeManagement"],
      },
      component: () =>
        import("../views/Device-manage/UpgradeManagement/upgrade-detail.vue"),
    },
    {
      path: "/versionDetail",
      name: "versionDetail",
      meta: {
        parent: ["deviceManage", "versionManagement"],
        current: ["versionManagement"],
      },
      component: () =>
        import("../views/Device-manage/versionManagement/version-detail.vue"),
    },
    // 用户注册
    {
      path: "/visitorList",
      name: "visitorList",
      meta: {
        parent: ["operationsAnalysis", "userDataInformation"],
        current: ["userRegistrationReport"],
      },
      component: () =>
        import(
          "../views/operationsAnalysis-mange/userDataInformation/userRegistrationReport/listAll/visitorList.vue"
        ),
    },
    {
      path: "/registrationList",
      name: "registrationList",
      meta: {
        parent: ["operationsAnalysis", "userDataInformation"],
        current: ["userRegistrationReport"],
      },
      component: () =>
        import(
          "../views/operationsAnalysis-mange/userDataInformation/userRegistrationReport/listAll/registrationList.vue"
        ),
    },
    // 活跃用户
    {
      path: "/activeUserList",
      name: "activeUserList",
      meta: {
        parent: ["operationsAnalysis", "userDataInformation"],
        current: ["ActiveUserReport"],
      },
      component: () =>
        import(
          "../views/operationsAnalysis-mange/userDataInformation/ActiveUserReport/listAll/activeUserList.vue"
        ),
    },
    {
      path: "/checkUserList",
      name: "checkUserList",
      meta: {
        parent: ["operationsAnalysis", "userDataInformation"],
        current: ["ActiveUserReport"],
      },
      component: () =>
        import(
          "../views/operationsAnalysis-mange/userDataInformation/ActiveUserReport/listAll/checkUserList.vue"
        ),
    },
    // 用户充电习惯
    {
      path: "/chargingSettings",
      name: "chargingSettings",
      meta: {
        parent: ["operationsAnalysis", "userDataInformation"],
        current: ["UserChargingReport"],
      },
      component: () =>
        import(
          "../views/operationsAnalysis-mange/userDataInformation/UserChargingReport/listAll/chargingSettings.vue"
        ),
    },
    {
      path: "/chargingOrders",
      name: "chargingOrders",
      meta: {
        parent: ["operationsAnalysis", "userDataInformation"],
        current: ["UserChargingReport"],
      },
      component: () =>
        import(
          "../views/operationsAnalysis-mange/userDataInformation/UserChargingReport/listAll/chargingOrders.vue"
        ),
    },

    {
      path: "/chargingOrdersTimePeriods",
      name: "chargingOrdersTimePeriods",
      meta: {
        parent: ["operationsAnalysis", "userDataInformation"],
        current: ["UserChargingReport"],
      },
      component: () =>
        import(
          "../views/operationsAnalysis-mange/userDataInformation/UserChargingReport/listAll/chargingOrdersTimePeriods.vue"
        ),
    },
    {
      path: "/chargingCapacity",
      name: "chargingCapacity",
      meta: {
        parent: ["operationsAnalysis", "userDataInformation"],
        current: ["UserChargingReport"],
      },
      component: () =>
        import(
          "../views/operationsAnalysis-mange/userDataInformation/UserChargingReport/listAll/chargingCapacity.vue"
        ),
    },
    //  充电桩绑定列表
    {
      path: "/bindingList",
      name: "bindingList",
      meta: {
        parent: ["operationsAnalysis", "stationBindingInfo"],
        current: ["stationBindingReport"],
      },
      component: () =>
        import(
          "../views/operationsAnalysis-mange/stationBindingInfo/listAll/bindingList.vue"
        ),
    },
    {
      path: "/categoryList",
      name: "categoryList",
      meta: {
        parent: ["operationsAnalysis", "stationBindingInfo"],
        current: ["stationBindingReport"],
      },
      component: () =>
        import(
          "../views/operationsAnalysis-mange/stationBindingInfo/listAll/categoryList.vue"
        ),
    },

    // 订单类型列表
    {
      path: "/orderTypeList",
      name: "orderTypeList",
      meta: {
        parent: ["operationsAnalysis", "chargingOrderInfo"],
        current: ["OrderTypeReport"],
      },
      component: () =>
        import(
          "../views/operationsAnalysis-mange/chargingOrderInfo/listAll/orderTypeList.vue"
        ),
    },
    // 优惠券配置详情
    {
      path: "/couponDetail",
      name: "couponDetail",
      meta: {
        parent: ["operationConfiguration", "couponManagement"],
        current: ["couponAllocation"],
      },
      component: () =>
        import(
          "../views/operationConfiguration/couponManagement/couponAllocation/detail.vue"
        ),
    },
    {
      path: "/updateLog",
      name: "updateLog",
      meta: {
        parent: ["operationConfiguration", "couponManagement"],
        current: ["couponAllocation"],
      },
      component: () =>
        import(
          "../views/operationConfiguration/couponManagement/couponAllocation/updateLog.vue"
        ),
    },
    {
      path: "/advUpdateLog",
      name: "advUpdateLog",
      meta: {
        parent: ["operationConfiguration", "advertisingSpaceManagement"],
        current: ["couponAllocation"],
      },
      component: () =>
        import(
          "../views/operationConfiguration/advertisingSpaceManagement/advertisingSpaceConfiguration/updateLog.vue"
        ),
    },
    {
      path: "/advDetail",
      name: "advDetail",
      meta: {
        parent: ["operationConfiguration", "advertisingSpaceManagement"],
        current: ["couponAllocation"],
      },
      component: () =>
        import(
          "../views/operationConfiguration/advertisingSpaceManagement/advertisingSpaceConfiguration/detail.vue"
        ),
    },
    {
      path: "/historyViewing",
      name: "historyViewing",
      meta: {
        parent: ["operationConfiguration", "advertisingSpaceManagement"],
        current: ["advertisingSpaceConfiguration"],
      },
      component: () =>
        import(
          "../views/operationConfiguration/advertisingSpaceManagement/advertisingSpaceConfiguration/historyViewing.vue"
        ),
    },
    {
      path: "/announceDetail",
      name: "announceDetail",
      meta: {
        parent: ["operationConfiguration", "advertisingSpaceManagement"],
        current: ["announcementBoardConfiguration"],
      },
      component: () =>
        import(
          "../views/operationConfiguration/advertisingSpaceManagement/announcementBoardConfiguration/detail.vue"
        ),
    },
    // 广告位
    {
      path: "/personalList",
      name: "personalList",
      meta: {
        parent: ["deviceManage", "operationalData"],
        current: ["operationalData"],
      },
      component: () =>
        import(
          "../views/operationsAnalysis-mange/advertisingInformation/clickReport/listAll/personalList.vue"
        ),
    },
    {
      path: "/purchasingList",
      name: "purchasingList",
      meta: {
        parent: ["deviceManage", "operationalData"],
        current: ["operationalData"],
      },
      component: () =>
        import(
          "../views/operationsAnalysis-mange/advertisingInformation/clickReport/listAll/purchasingList.vue"
        ),
    },
    {
      path: "/bulletinBoardList",
      name: "bulletinBoardList",
      meta: {
        parent: ["deviceManage", "operationalData"],
        current: ["operationalData"],
      },
      component: () =>
        import(
          "../views/operationsAnalysis-mange/advertisingInformation/bulletinBoard/listAll/bulletinBoardList.vue"
        ),
    },

    {
      path: "/activityOrderZreoListDetail",
      name: "activityOrderZreoListDetail",
      meta: {
        parent: ["chargeOrderManage", "activityOrderZreo"],
        current: ["activityOrderZreoList"],
      },
      component: () =>
        import("../views/cust-pile-plan/activity-order-list/detail.vue"),
    },
    {
      path: "/packageZreoListDetail",
      name: "packageZreoListDetail",
      meta: {
        parent: ["chargeOrderManage"],
        current: ["packageList"],
      },
      component: () =>
        import("../views/cust-pile-plan/package-list/detail.vue"),
    },
    {
      path: "/familyChargingProductOrderDetail",
      name: "familyChargingProductOrderDetail",
      meta: {
        parent: ["chargeOrderManage"],
        current: ["familyChargingServiceActivity"],
      },
      component: () =>
        import(
          "../views/charging-manage/family-charging-product-order/detail.vue"
        ),
    },
    {
      path: "/anxinPackDetail",
      name: "anxinPackDetail",
      meta: {
        parent: ["marketingActivity", "axbActivity"],
        current: ["axbProductOrder"],
      },
      component: () => import("../views/marketingActivity/anxinPack/detail.vue"),
    },
    {
      path: "/anxinPackActivityDetail",
      name: "anxinPackActivityDetail",
      meta: {
        parent: ["marketingActivity", "axbActivity"],
        current: ["axbServiceList"],
      },
      component: () => import("../views/marketingActivity/anxinPackActivity/detail.vue"),
    },
    {
      path: "/pileDonationProductOrderDetail",
      name: "pileDonationProductOrderDetail",
      meta: {
        parent: ["marketingActivity", "pileDonationActivity"],
        current: ["productOrder"],
      },
      component: () =>
        import(
          "../views/marketingActivity/pileDonationActivity/detail.vue"
        ),
    },

    {
      // 活动折扣券 - 关联用户表
      path: "/activityDiscountListDetail",
      name: "activityDiscountListDetail",
      meta: {
        parent: ["chargeOrderManage", "activityOrderZreo"],
        current: ["activityDiscountList"],
      },
      component: () =>
        import("../views/cust-pile-plan/activity-discount-list/detail.vue"),
    },

    // 老499活动订单详情（原"活动 499 弃用"注释恢复，列表页"活动订单编辑"跳转依赖此路由）
    {
      path: "/activityOrderDetail",
      name: "activityOrderDetail",
      meta: {
        parent: ["marketingActivity"],
        current: ["old499ActivityOrderList"],
      },
      component: () =>
        import(
          "../views/activity-manage/activity-order-list/detail.vue"
        ),
    },

    // {
    //   path: "/activityDetail",
    //   name: "activityDetail",
    //   meta: {
    //     parent: ["activity", "activityManagement"],
    //     current: ["activityDetail"],
    //   },
    //   component: () => import("../views/service-activity/detial.vue"),
    // },
    // {
    //   path: "/activityPreview",
    //   name: "activityPreview",
    //   meta: {
    //     parent: ["activity", "activityManagement"],
    //     current: ["activityPreview"],
    //   },
    //   component: () => import("../views/service-activity/preview.vue"),
    // },

    // {
    //   path: "/commodityDetial",
    //   name: "commodityDetial",
    //   meta: {
    //     parent: ["commodity", "commodityList"],
    //     current: ["commodityDetial"],
    //   },
    //   component: () => import("../views/commodity-list/detial.vue"),
    // },
  ],
};

export default otherRouters;
